import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HomeView from './HomeView';
import Loading from './Loading';
import ErrorBoundary from './ErrorBoundary';
import logo from '../../assets/images/big-c.jpg';
import './main.css';

const GameFortuneCardHome = () => {
  const userId = localStorage.getItem("userId") ?? "";
  const [profile, setProfile] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Get profile from localStorage
    const initProfile = () => {
      try {
        const lineMid = userId || localStorage.getItem('userId');
        const displayName = localStorage.getItem('line_display_name') || 'ผู้เล่น';
        const bigCardNumber = localStorage.getItem('bigCardNumber');

        if (!lineMid) {
          console.error('No LINE MID found');
          return;
        }

        setProfile({
          userId: lineMid,
          displayName: displayName,
          bigCardNumber: bigCardNumber,
        });

        setIsReady(true);
      } catch (err) {
        console.error('Profile initialization error:', err);
      }
    };

    initProfile();
  }, [userId]);

  const handleStartGame = () => {
    // ✅ Navigate to result page
    navigate('/game/fortune-card/result');
  };

  if (!isReady || !profile) {
    return <Loading message="กำลังเตรียมข้อมูล..." />;
  }

  return (
    <div className="app-game">
      <main className="phone">
        <img className="logo-image" src={logo} alt="Big C logo" />
        <ErrorBoundary>
          <HomeView onStart={handleStartGame} />
        </ErrorBoundary>
      </main>
    </div>
  );
};

export default GameFortuneCardHome;